let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6yWWK")).then(() => parcelRequire('ihj3F'));